import {
    type AgebandPricingData,
    type FlatPricingData,
    PricingType,
} from '@travelity/api/generated';
import { AgebandName } from '@travelity/api/services';
import type {
    PackageBookingFormValues,
    PackageBookingItemMeta,
} from '@/views/availability/components/PackageBookingSideform/package-form.helpers';

export const getSelectedOptionPrice = (
    pricing: PackageBookingItemMeta['optionsCatalog'][number]['pricing'],
    pax: PackageBookingFormValues['pax']
) => {
    const pricingItem = pricing?.items?.[0];
    if (!pricingItem) return undefined;

    const price = pricingItem.price.original;
    const currency = pricingItem.currency.abbr;

    if (typeof price === 'number') {
        return {
            total: price,
            currency,
        };
    }

    const baseAmount = price.base_amount ?? 0;

    if (pricingItem.type === PricingType.PER_PRODUCT) {
        return {
            total: baseAmount + (price as FlatPricingData).unit_amount,
            currency,
        };
    }

    if (pricingItem.type === PricingType.PER_PERSON) {
        const paxCount = Object.values(pax).reduce(
            (sum, ageBandCount) => sum + (ageBandCount || 0),
            0
        );

        return {
            total:
                baseAmount +
                paxCount * ((price as FlatPricingData).unit_amount || 0),
            currency,
        };
    }

    const agebandPrice = price as AgebandPricingData;
    const paxTotal = Object.values(AgebandName).reduce((sum, ageBandName) => {
        const agebandCount = pax[ageBandName] || 0;
        const unitAmount = agebandPrice[ageBandName] || 0;

        return sum + agebandCount * unitAmount;
    }, 0);

    return {
        total: baseAmount + paxTotal,
        currency,
    };
};
